import { usePage } from "@inertiajs/react"
import { SeoHead } from "@/components/SeoHead"
import {
  organizationNode,
  websiteNode,
  serviceNode,
  personHarryNode,
  faqPageNode,
} from "@/lib/seo"
import { FAQS } from "@/components/marketing/sections/faqData"
import type { PageProps } from "@/types/inertia"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { Hero } from "@/components/marketing/sections/Hero"
import { CredibilityStrip } from "@/components/marketing/sections/CredibilityStrip"
import { Problem } from "@/components/marketing/sections/Problem"
import { Mechanism } from "@/components/marketing/sections/Mechanism"
import { Offer } from "@/components/marketing/sections/Offer"
import { GrowthLoop } from "@/components/marketing/sections/GrowthLoop"
import { GuestPipelineBoundary } from "@/components/marketing/sections/GuestPipelineBoundary"
import { ForWhom } from "@/components/marketing/sections/ForWhom"
import { Founder } from "@/components/marketing/sections/Founder"
import { Proof } from "@/components/marketing/sections/Proof"
import { Faq } from "@/components/marketing/sections/Faq"
import { FinalCta } from "@/components/marketing/sections/FinalCta"

const DESCRIPTION =
  "FullCast helps established founders, coaches, consultants, and expert-led businesses turn weekly video podcast interviews into authority-building content and strategic relationships."

export default function Home() {
  const base = (usePage<PageProps>().props.app_url || "https://fullcast.co").replace(/\/$/, "")

  return (
    <MarketingLayout>
      <SeoHead
        title="Build Authority Through Better Conversations"
        description={DESCRIPTION}
        jsonLd={[
          organizationNode(base),
          websiteNode(base),
          serviceNode(base),
          personHarryNode(base),
          faqPageNode(FAQS),
        ]}
      />

      <Hero />
      <CredibilityStrip />
      <Problem />
      <Mechanism />
      <Offer />
      <GrowthLoop />
      <GuestPipelineBoundary />
      <ForWhom />
      <Founder />
      <Proof />
      <Faq />
      <FinalCta />
    </MarketingLayout>
  )
}
